import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

function TaskForm() {
  const [task, setTask] = useState("");
  const [tasks, setTasks] = useState(() => {
    const savedTasks = localStorage.getItem("tasks");
    return savedTasks ? JSON.parse(savedTasks) : [];
  });
  const [editIndex, setEditIndex] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    localStorage.setItem("tasks", JSON.stringify(tasks));
  }, [tasks]);

  const addingTask = (e) => {
    e.preventDefault();
    if (task.trim() !== "") {
      if (editIndex !== null) {
        const updatedTasks = [...tasks];
        updatedTasks[editIndex] = task;
        setTasks(updatedTasks);
        setEditIndex(null);
      } else {
        setTasks([...tasks, task]);
      }
      setTask("");
    }
  };

  const deleteTask = (index) => {
    const updatedTasks = [...tasks];
    updatedTasks.splice(index, 1);
    setTasks(updatedTasks);

    if (updatedTasks.length === 0) {
      setShowPopup(true);
    }
  };

  const editTask = (index) => {
    setEditIndex(index);
    setTask(tasks[index]);
  };

  return (
    <div className="max-w-md mx-auto p-4 bg-slate-900 rounded-lg border-2 border-white relative mt-16 mb-32">
      <h2 className="text-lg font-semibold mb-4 text-center">What's the Plan for Today?</h2>
      <form className="flex flex-col sm:flex-row items-center" onSubmit={addingTask}>
        <input
          type="text"
          placeholder="Enter task"
          value={task}
          className="border bg-slate-800 mt-4 sm:mt-0 border-gray-300 px-4 py-2 mr-2 mb-2 sm:mb-0 rounded-md flex-grow"
          onChange={(e) => setTask(e.target.value)}
        />
        <button
          type="submit"
          className="text-emerald-600 text-2xl bg-slate-900 px-2 py-1 rounded-md border-1 border-emerald-500"
        >
          +
        </button>
      </form>
      <ul className="mt-5 list-none">
        {tasks.map((task, index) => (
          <li key={index} className="flex items-center justify-between border-b border-green-600 py-2">
            <span>{task}</span>
            <div>
              <div className="flex gap-2">
                <FaEdit className="text-blue-500 cursor-pointer" onClick={() => editTask(index)} />
                <FaTrash className="text-red-500 cursor-pointer" onClick={() => deleteTask(index)} />
              </div>
            </div>
          </li>
        ))}
      </ul>
      {showPopup && (
        <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-75">
          <div className="bg-black p-6 rounded-lg">
            <span role="img" aria-label="Party Emoji" className="text-4xl ">
              🎉🎊
            </span>
            <p className="text-xl mt-4">All tasks completed! It's time to celebrate!</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default TaskForm;
